module.exports = __webpack_public_path__ + "static/img/foundry_256.b1ec3cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundry_256.png
// module id = Eu07
// module chunks = 0